/* eslint-disable no-console */
import { ref } from 'vue';

const countData = ref([]);

const filterCheckers = {
  type: (a, b) => {
    if (Array.isArray(b)) {
      return b.includes(a);
    }

    if (typeof b === 'string' && b.includes(',')) {
      const types = b.split(',').map((t) => t.trim());

      return types.includes(a);
    }

    return a === b;
  },

  universities: (a, b) => {
    if (Array.isArray(a)) {
      return a.includes(b);
    }

    return a === b;
  },

  area_id: (a, b) => a === b,
  price_min: (a, b) => parseInt(a) >= parseInt(b),
  price_max: (a, b) => parseInt(a) <= parseInt(b),
  bedroom_count: (a, b) => parseInt(a) === parseInt(b),
  bathroom_count: (a, b) => parseInt(a) >= parseInt(b),
};

export default () => {
  const isLoading = ref(false);

  // Get the filter count endpoint.
  const getEndpoint = (city) => `/api/v1/properties/${city}/filter-counts`;

  // Fetch the count data for the city.
  const fetchCounts = async (city) => {
    isLoading.value = true;

    const endpoint = getEndpoint(city);
    const res = await fetch(endpoint);

    isLoading.value = false;

    if (!res.ok) {
      console.error('Failed to get filter counts');

      return;
    }

    countData.value = await res.json();
  };

  const filterResults = (filters) => {
    const properties = Object.keys(filters);

    // Store the filtered data.
    let filteredData = countData.value;

    properties.forEach((property) => {
      const value = filters[property] ?? undefined;

      filteredData = filteredData.filter((data) => {
        const filterChecker = filterCheckers[property] ?? undefined;

        // Skip the filter check if we don't have the filter checker, property or value.
        if (!filterChecker || !data[property] || !value) {
          return true;
        }

        return filterChecker(data[property], value);
      });
    });

    return filteredData;
  };

  const filterCount = (filters) => {
    const results = filterResults(filters);

    return results.length ?? 0;
  };

  return {
    isLoading,

    filterCount,
    filterResults,
    fetchCounts,
  };
};
